module.exports = __webpack_public_path__ + "img/example_1.f298517f.png";